/*
 *  Document   : candidate-edit.js
 *  Author     : Exapoint
 *
 */

// Import global dependencies

// Import required modules

// Tools
import ExaHelpers from "../exa_helpers";
import Fuse from "fuse.js";

export default class CandidateEdit {

    /*
    * Auto called when creating a new instance
    *
    */
    constructor() {
        window["CandidateEdit"] = this;
        this.init();
    }

    /*
     * Updates the color theme
     *
     */
    init() {
        this.markersArray = [];
        ExaHelpers.addScript(
            'https://maps.googleapis.com/maps/api/js?libraries=places&callback=Function.prototype&key=' + googleMapsApiKey,
            function () {
                this.initMap();
                this.initCountryRestriction(); // Triggers initAutocomplete
            }.bind(this)
        );

        this.latInput = $('[name="lat"]');
        this.lngInput = $('[name="lng"]');

        CandidateEdit.initLanguagesSelect($('#candidate-edit-languages-select2'));

        ExaHelpers.validation();
        this.initValidation();

        this.initAboutMeTextEditor();

        this.initDropzone();

        this.initProfilePictureDropzone();

        this.initWebcam();

        if (jsVars.showEmptyProfessionsAlert) {
            this.showEmptyProfessionsAlert();
        }
    }

    initMap() {
        this.map = new google.maps.Map(document.getElementById('map'), {
            zoom: 17
        });

        let latValue = parseFloat(this.latInput.val());
        let lngValue = parseFloat(this.lngInput.val());
        if (!isNaN(latValue) && !isNaN(lngValue)) {
            this.showOnMap(latValue, lngValue);
        }

        this.map.addListener('click', function (event) {
            this.handleMapClick(event);
        }.bind(this));
    }

    initAutocomplete(selectedCountryCode) {
        let acInput = document.getElementById('autocomplete');
        let type = '';

        $(acInput).on('focus', function (e) {
            CandidateEdit.acSelected = false;
        }).on('blur', function (e) {
            setTimeout(function () {
                type = document.activeElement ? document.activeElement.type : '';
                if (!CandidateEdit.acSelected && type !== 'search' && type !== 'button') {
                    CandidateEdit.clearAddressAndAlert();
                }
            }, 500);
        });
//https://developers.google.com/places/web-service/autocomplete
        this.autocomplete = new google.maps.places.Autocomplete(
            acInput, {
            //    types: ['address'],  //geocode  ,  establishment
                region: 'EU',
                strictBounds: true,
                fields: ['address_component', 'geometry', 'name'],
                componentRestrictions: {country: selectedCountryCode},
            }
        );

        $(acInput).bind('keypress keydown keyup', function (e) {
            if (e.keyCode === 13) {
                e.preventDefault();
            }
        });

        this.autocomplete.addListener('place_changed', function () {
            CandidateEdit.acSelected = true;
            let place = this.autocomplete.getPlace();

            if (typeof place["address_components"] == "undefined") {
                CandidateEdit.clearAddressAndAlert();
            }

            $('[name="address_line_1"]').val(place['name']);
            $('[name="city"]').val(this.getAddressComponentByType(place["address_components"], 'locality', 'long_name'));
            $('[name="postcode"]').val(this.getAddressComponentByType(place["address_components"], 'postal_code', 'long_name'));
            $('[name="google_maps_result"]').val(JSON.stringify(place));
            this.showOnMap(place.geometry.location.lat(), place.geometry.location.lng());
            this.updateLatLngInputs(place.geometry.location);
        }.bind(this));

    }

    initCountryRestriction() {
        $("select[name='country_id']").on('change', function (e) {
            // Old implementation when country code was used instead of just the name
            // let selectedCountryCode = $(e.target).find('option:selected').text();
            let selectedCountryCode = Object.keys(jsVars.countryCodesArray).find(key => jsVars.countryCodesArray[key] === $(e.target).find('option:selected').text());
            selectedCountryCode = selectedCountryCode && selectedCountryCode.trim() !== "" ? selectedCountryCode.trim().toLowerCase() : 'ch';

            if (typeof this.autocomplete === "undefined") {
                this.initAutocomplete(selectedCountryCode);
            } else {
                this.autocomplete.setComponentRestrictions({country: [selectedCountryCode]});
            }
        }.bind(this)).change();
    }

    static clearAddressAndAlert() {
        $('[name="address_line_1"], [name="address_line_2"], [name="postcode"], [name="city"], [name="google_maps_result"], [name="lat"], [name="lng"]').val('');
        alert(jsVars.acSelectText);
    }

    showOnMap(geoLat, geoLng) {
        let myLatLng = {lat: geoLat, lng: geoLng};

        let marker = new google.maps.Marker({
            position: myLatLng,
            map: this.map,
        });

        this.clearOverlays();
        this.markersArray.push(marker);
        this.showOverlays();

        this.map.panTo(myLatLng);
    }

    getAddressComponentByType(addressComponents, addressType, property) {
        let result = '';
        if (addressComponents) {
            addressComponents.forEach(function (element) {
                if (element['types'].indexOf(addressType) !== -1) {
                    result = element[property];
                    return false;
                }
            });
        }
        return result;
    }

    // Removes the overlays from the map, but keeps them in the array
    clearOverlays() {
        if (this.markersArray) {
            for (let i in this.markersArray) {
                this.markersArray[i].setMap(null);
            }
        }
        this.markersArray = [];
    }

    // Shows any overlays currently in the array
    showOverlays() {
        if (this.markersArray) {
            for (let i in this.markersArray) {
                this.markersArray[i].setMap(this.map);
            }
        }
    }

    handleMapClick(event) {
        this.clearOverlays();
        let marker = new google.maps.Marker({
            position: event.latLng,
            map: this.map
        });
        this.markersArray = [];
        this.markersArray.push(marker);
        this.showOverlays();
        this.updateLatLngInputs(event.latLng);

        var latLng = event.latLng;
        const geocoder = new google.maps.Geocoder();

        const latlng = {
            lat: parseFloat(this.latInput.val()),
            lng: parseFloat(this.lngInput.val()),
          };

        geocoder.geocode({ location: latlng }, (results, status) => {
            if (status === "OK") {
              if (results[0]) {
               var searchAddressComponents = results[0].address_components;
                //console.log(searchAddressComponents);

               var searchPostalCode, searchroute, searchlocality, searchNumber = "";
               $.each(searchAddressComponents, function(){
                    if(this.types[0]=="postal_code"){
                        searchPostalCode=this.short_name;
                    }
                    if(this.types[0]=="route"){
                        searchroute=this.short_name;
                    }
                    if(this.types[0]=="locality"){
                        searchlocality=this.short_name;
                    }
                    if(this.types[0]=="street_number"){
                        searchNumber=this.short_name;
                    }
                });

                   if('Unnamed Road' == searchroute ){
                       CandidateEdit.clearAddressAndAlert();
                   }else{
                        $('[name="postcode"]').val(searchPostalCode);
                        $('[name="address_line_1"]').val(searchNumber+" "+searchroute);
                        $('[name="address_line_2"]').val("");
                        $('[name="city"]').val(searchlocality);
                    }

              } else {
                //window.alert("No results found");
                CandidateEdit.clearAddressAndAlert();
              }
            } else {
              //window.alert("Geocoder failed due to: " + status);
              CandidateEdit.clearAddressAndAlert();
            }
          });


    }

    updateLatLngInputs(latLng) {
        this.latInput.val(latLng.lat);
        this.lngInput.val(latLng.lng);
    }

    initDropzone() {
        let $candidateFilesDropzone = $('#candidate-files');
        let $drivingLicenceDropzone = $('#driving-licences-dropzone');
        let $residencePermitDropzone = $('#residence-permit-dropzone');
        let $curriculumDropzone = $('#curriculum-dropzone');

        Dropzone.options.candidateFiles = {
            init: function () {
                let thisDropzone = this;
                let $thisElement = $(thisDropzone.element);

                $.get(jsVars.getFilesUrl, function (data) {
                    $.each(data, function (key, value) {
                        let file = {
                            processing: true,
                            accepted: true,
                            name: value.originalName,
                            size: value.size,
                            type: value.mimeType,
                            status: Dropzone.SUCCESS,
                            downloadLink: value.path,
                        };
                        thisDropzone.files.push(file);
                        thisDropzone.emit("addedfile", file);
                        if (value.thumbnail) {
                            thisDropzone.emit("thumbnail", file, Laravel.app_url + value.thumbnail);
                        }
                        thisDropzone.emit("processing", file);
                        thisDropzone.emit("success", file, {status: "success"}, false);
                        thisDropzone.emit("complete", file);
                        file.path = value.path;
                    });
                });

                $thisElement.on('click', '[data-dz-name]', function (e) {
                    let $target = $(e.target);
                    let $fileContainer = $target.parents('.dz-preview');
                    let downloadLink = $fileContainer.find('.dz-file-download-link').val();

                    window.open(Laravel.app_url + '/storage/' + downloadLink, '_blank');
                })
            },
            success: function (file, response) {
                file.path = response.path;

                let link = file.downloadLink || file.path;
                if (link) {
                    // Save download link to hidden input for click to open to work
                    file.previewTemplate.insertAdjacentHTML('beforeend',
                        `<input type="hidden" class="dz-file-download-link" value="${link}" />`);
                }

                if (typeof file.downloadLink === "undefined") {
                    $(file.previewElement).addClass("dz-success");
                    setTimeout(function () {
                        $(file.previewElement).removeClass("dz-success");
                    }, 2750);
                }

                if (typeof response.path !== "undefined" && $candidateFilesDropzone[0] === this.element) {
                    Dashmix.helpers('notify', {
                        align: 'center',
                        type: 'success',
                        icon: 'fa fa-check mr-1 mt-5 mb-5',
                        message: jsVars.fileUploadedSuccessTab
                    });
                }
            },
            error: function (file, message) {
                if (typeof file == "undefined") {
                    console.error(file, message);
                }
                $(file.previewElement).addClass("dz-error");
                if (message.errors) {
                    $(file.previewElement).find('.dz-error-message').text(message.errors.file);
                }
            },
            addRemoveLinks: true,
            removedfile: function (file) {
                $.ajax({
                    type: 'POST',
                    url: jsVars.removeFile,
                    data: {
                        _token: Laravel.csrfToken,
                        pathToRemove: file.path
                    },
                });
                var _ref;
                return (_ref = file.previewElement) != null ? _ref.parentNode.removeChild(file.previewElement) : void 0;
            },
        };

        $candidateFilesDropzone.addClass('dropzone');
        $candidateFilesDropzone.dropzone();

        Dropzone.options.drivingLicencesDropzone = Dropzone.options.candidateFiles;
        Dropzone.options.drivingLicencesDropzone.url = jsVars.candidateSaveFileUrl;
        Dropzone.options.drivingLicencesDropzone.sending = function (file, xhr, formData) {
            formData.append("_token", Laravel.csrfToken);
        };
        Dropzone.options.drivingLicencesDropzone.init = () => {
        };

        mainDropzone = $candidateFilesDropzone.get(0).dropzone;
        parentSuccessMethod = Dropzone.options.drivingLicencesDropzone.success;

        Dropzone.options.drivingLicencesDropzone.success = function (file, response) {
            let result = parentSuccessMethod.apply(this, [file, response]);

            Dashmix.helpers('notify', {
                align: 'center',
                type: 'success',
                icon: 'fa fa-check mr-1 mt-5 mb-5',
                message: jsVars.fileUploadedSeeOtherTab
            });
            /*
            // Attempt to sync dropzones

            let newFile = {
                processing: true,
                accepted: true,
                name: file.upload.filename,
                size: file.size,
                type: file.mimeType,
                status: Dropzone.SUCCESS,
                downloadLink: file.path,
            };
            mainDropzone.files.push(newFile);
            mainDropzone.emit("addedfile", newFile);
            if (file.path) {
                mainDropzone.emit("thumbnail", newFile, `/storage/${file.path}`);
            }
            mainDropzone.emit("processing", newFile);
            mainDropzone.emit("success", newFile, {status: "success"}, false);
            mainDropzone.emit("complete", newFile);
            newFile.path = file.path;
            */
        }

        /*let parentRemoveMethod = Dropzone.options.drivingLicencesDropzone.removeFile;
        Dropzone.options.drivingLicencesDropzone.removeFile = function (file) {
            let result = parentRemoveMethod.apply(this, [file]);
            mainDropzone.removeFile(file);
        }*/

        $drivingLicenceDropzone.addClass('dropzone');
        $drivingLicenceDropzone.dropzone();

        Dropzone.options.residencePermitDropzone = Dropzone.options.drivingLicencesDropzone;
        $residencePermitDropzone.addClass('dropzone');
        $residencePermitDropzone.dropzone();





        Dropzone.options.curriculumDropzone = {
            init: function () {
                let thisDropzone = this;
                let $thisElement = $(thisDropzone.element);

                $.get(jsVars.getCurriculumUrl, function (data) {
                    $.each(data, function (key, value) {
                        let file = {
                            processing: true,
                            accepted: true,
                            name: value.originalName,
                            size: value.size,
                            type: value.mimeType,
                            status: Dropzone.SUCCESS,
                            downloadLink: value.path,
                        };
                        thisDropzone.files.push(file);
                        thisDropzone.emit("addedfile", file);
                        if (value.thumbnail) {
                            thisDropzone.emit("thumbnail", file, Laravel.app_url + value.thumbnail);
                        }
                        thisDropzone.emit("processing", file);
                        thisDropzone.emit("success", file, {status: "success"}, false);
                        thisDropzone.emit("complete", file);
                        file.path = value.path;
                    });
                });

                $thisElement.on('click', '[data-dz-name]', function (e) {
                    let $target = $(e.target);
                    let $fileContainer = $target.parents('.dz-preview');
                    let downloadLink = $fileContainer.find('.dz-file-download-link').val();

                    window.open(Laravel.app_url + '/storage/' + downloadLink, '_blank');

                    //PDFObject.embed("https://pdfobject.com/pdf/sample-3pp.pdf", "#example1");




                })
            },
            success: function (file, response) {
                file.path = response.path;

                let link = file.downloadLink || file.path;
                if (link) {
                    // Save download link to hidden input for click to open to work
                    file.previewTemplate.insertAdjacentHTML('beforeend',
                        `<input type="hidden" class="dz-file-download-link" value="${link}" />`);
                }

                if (typeof file.downloadLink === "undefined") {
                    $(file.previewElement).addClass("dz-success");
                    setTimeout(function () {
                        $(file.previewElement).removeClass("dz-success");
                    }, 2750);
                }

                if (typeof response.path !== "undefined" && $candidateFilesDropzone[0] === this.element) {
                    Dashmix.helpers('notify', {
                        align: 'center',
                        type: 'success',
                        icon: 'fa fa-check mr-1 mt-5 mb-5',
                        message: jsVars.fileUploadedSuccessTab
                    });
                }
            },
            error: function (file, message) {
                if (typeof file == "undefined") {
                    console.error(file, message);
                }
                $(file.previewElement).addClass("dz-error");
                if (message.errors) {
                    $(file.previewElement).find('.dz-error-message').text(message.errors.file);
                }
            },
            addRemoveLinks: true,
            removedfile: function (file) {
                $.ajax({
                    type: 'POST',
                    url: jsVars.removeCurriculum,
                    data: {
                        _token: Laravel.csrfToken,
                        pathToRemove: file.path
                    },
                });
                var _ref;
                return (_ref = file.previewElement) != null ? _ref.parentNode.removeChild(file.previewElement) : void 0;
            },
        };

      //  Dropzone.options.curriculumDropzone = Dropzone.options.drivingLicencesDropzone;
        Dropzone.options.curriculumDropzone.url = jsVars.saveCurriculumUrl;
        Dropzone.options.curriculumDropzone.sending = function (file, xhr, formData) {
            formData.append("_token", Laravel.csrfToken);
        };

        let mainDropzone = $curriculumDropzone.get(0).dropzone;
        let parentSuccessMethod = Dropzone.options.curriculumDropzone.success;

       /* Dropzone.options.curriculumDropzone.success = function (file, response) {
            let result = parentSuccessMethod.apply(this, [file, response]);

            Dashmix.helpers('notify', {
                align: 'center',
                type: 'success',
                icon: 'fa fa-check mr-1 mt-5 mb-5',
                message: jsVars.fileUploadedSeeOtherTab
            });
        }*/

        $curriculumDropzone.addClass('dropzone');
        $curriculumDropzone.dropzone();
    }

    static initLanguagesSelect($languagesSelect) {
        let app = this;
        app.removedAcItems = [];

        app.fuse = new Fuse(jsVars.languagesAutocompleteValues, {
            minMatchCharLength: 1,
            threshold: 0.3,
            distance: 1000,
            keys: ["name"],
            getFn: (obj, path) => {
                return obj.name.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
            }
        })

        let $jtAc = $languagesSelect;
        let selectedValues = [];
        $('[type="hidden"][name*="userable[languages]"]').each(function (_i, val) {
            let parsedId = parseInt(ExaHelpers.extractFieldFromName($(val).prop('name')));
            if (!isNaN(parsedId)) {
                selectedValues.push(parsedId);
            }
        })

        $jtAc.autocomplete({
            delay: 0,
            minLength: 0,
            source: function (req, callback) {
                let term = req.term.normalize('NFD').replace(/[\u0300-\u036f]/g, "");

                let options = [];
                $.each(app.fuse.search(term, {limit: 10}), function (index, obj) {
                    options.push({value: obj.item.id, label: obj.item.name, wholeObject: obj.item});
                });

                callback(options);
            },
            select: function (event, ui) {
                var label = ui.item.label;
                var value = ui.item.value;

                let indexToRemove = app.fuse._docs.findIndex(x => x.id === parseInt(value));
                if (indexToRemove !== -1) {
                    app.removedAcItems.push(app.fuse._docs[indexToRemove]);
                    app.fuse.removeAt(indexToRemove);
                }

                let newValue = ui.item.wholeObject;

                // Custom part - start
                let $table = $('.languages-table');

                let optionsHtml = '';
                for (let i in jsVars.languageLevelsArray) {
                    optionsHtml += `<option value="${i}">${jsVars.languageLevelsArray[i]}</option>`;
                }
                let $htmlToAppend = $(app.languagesRowTemplate(newValue, null));
                $htmlToAppend.find('select').append(optionsHtml);

                $table.find('tbody').append($htmlToAppend);

                if ($table.find('tr.single-language') && $table.find('tr.single-language').length !== 0) {
                    $table.show();
                } else {
                    $table.hide();
                }

                // Custom part - end

                $(this).val('');
                return false;
            },
            focus: function (event, ui) {
                $(this).val(ui.item.label);
                return false;
            }
        });

        $.each(selectedValues, function (_i, value) {
            let indexToRemove = app.fuse._docs.findIndex(x => x.id === parseInt(value));
            if (indexToRemove !== -1) {
                app.removedAcItems.push(app.fuse._docs[indexToRemove]);
                app.fuse.removeAt(indexToRemove);
            }
        })
    }

    initValidation() {
        let $nationalityId = $("[name='userable[nationality_id]']");
        let $residencePermitDropzoneContainer = $('.residence-permit-dropzone-container');

        let $residencePermit = $('[name="userable[residence_permit_id]"]');
        let $residencePermitOtherInfo = $('[name="userable[residence_permit_other]"]');
        $residencePermit.on('change', function () {
            let requiresOtherInfo = $residencePermit.find("option:selected").data('requiresOtherInfo') === 1;

            if (!requiresOtherInfo) {
                $residencePermitOtherInfo.parents('.form-group').hide();
            } else {
                $residencePermitOtherInfo.parents('.form-group').show();
            }

            if( $residencePermit.find("option:selected").data('requiresOtherInfo') == -1 ){
               $('[name="userable[residence_permit_valid_until]"]').parents('.form-group').hide();
               $residencePermitDropzoneContainer.hide();
            }

            if( $residencePermit.find("option:selected").data('requiresOtherInfo') == 0 ){
               $('[name="userable[residence_permit_valid_until]"]').parents('.form-group').show();
               $residencePermitDropzoneContainer.show();
            }

        });

        $nationalityId.on('change', function (e) {
            if ($(e.target).find("option:selected").data('requiresPermit') === 1) {
                $('[name*="userable[residence_permit"]').each((index, element) => {
                    let $residenceInput = $(element);
                    let $parentGroup = $residenceInput.parents('.form-group');
                    if ($parentGroup.is(":hidden")) {
                        $parentGroup.show();
                    }
                });
                $residencePermitDropzoneContainer.show();
            } else {
                $('[name*="userable[residence_permit"]').each((index, element) => {
                    let $residenceInput = $(element);
                    $residenceInput.parents('.form-group').hide();
                    if (typeof element._flatpickr !== "undefined") {
                        element._flatpickr.setDate('');
                    } else {
                        $residenceInput.val('');
                    }
                });
                $residencePermitDropzoneContainer.hide();
            }
            $residencePermit.change();
        }).change();


        $('.js-validation').validate({
            ignore: "[contenteditable='true']:not([name])",
            rules: {
                'gender_id': {
                    required: true,
                },
                'first_name': {
                    required: true,
                },
                'last_name': {
                    required: true,
                },
                'address_line_1': {
                    required: true,
                },
                'city': {
                    required: true,
                },
                'postcode': {
                    required: true,
                },
                'country_id': {
                    required: true,
                },
                'email': {
                    required: true,
                    email: true,
                },
                'mobile_number_intl': {
                    required: true,
                    intlTelNumber: true,
                },
                'phone_number_intl': {
                    intlTelNumber: true,
                },
                'date_of_birth': {
                    required: true,
                    dateISO: true,
                },
                'profile_picture': {
                    accept: "image/*"
                },
                'userable[nationality_id]': {
                    required: true,
                },
                'userable[work_radius]': {
                    required: true,
                    range: [1, 200]
                },
                'userable[residence_permit_id]': {
                    required: function (element) {
                        let requiresPermit = $nationalityId.find("option:selected").data('requiresPermit') === 1;
                        if (!requiresPermit) {
                            $(element).removeClass('is-invalid');
                            $(element).parent().find('.invalid-feedback').remove();
                        }

                        return requiresPermit;
                    }
                },
                'userable[residence_permit_other]': {
                    required: function (element) {
                        let requiresOtherInfo = $residencePermit.find("option:selected").data('requiresOtherInfo') === 1;
                        if (!requiresOtherInfo) {
                            $(element).removeClass('is-invalid');
                            $(element).parent().find('.invalid-feedback').remove();
                        }

                        if( $residencePermit.find("option:selected").data('requiresOtherInfo') == -1 ){
                            $(element).removeClass('is-invalid');
                            $(element).parent().find('.invalid-feedback').remove();
                            requiresOtherInfo = false;
                        }
                        return requiresOtherInfo;
                    }
                },
                'userable[residence_permit_valid_until]': {
                    required: function (element) {
                        let requiresPermit = $nationalityId.find("option:selected").data('requiresPermit') === 1;
                        if (!requiresPermit) {
                            $(element).removeClass('is-invalid');
                            $(element).parent().find('.invalid-feedback').remove();
                        }

                        if( $residencePermit.find("option:selected").data('requiresOtherInfo') == -1 ){
                            $(element).removeClass('is-invalid');
                            $(element).parent().find('.invalid-feedback').remove();
                            requiresPermit = false;
                        }
                        return requiresPermit;
                    },
                    dateISO: true
                },
            },
        });

        // Init Validation on Select2 change
        $('.js-select2:not(.skip-validation)').on('change', e => {
            $(e.currentTarget).valid();
        });

        let $table = $('.languages-table');
        $table.on('click', '.remove-language-row', function (e) {
            let $target = $(e.target);
            $target.parents('.single-language').remove();
        })
    }

    static languagesRowTemplate(datarecord, idx) {
        return `
<tr class="single-language">
    <td>
        <div class="d-flex align-items-center">
            <span class='placeholder mr-2 font-w400'>${datarecord.name}</span>
            <span>Niveau:</span><input name="userable[languages][${datarecord.id}]" type="hidden">
            <select class="" name="userable[languages][${datarecord.id}][language_level_id]"></select>
        </div>
    </td>
    <td>
    </td>
    <td>
        <i class="fa fa-fw fa-times remove-language-row"></i>
    </td>
</tr>
`;
    }

    initAboutMeTextEditor() {
        // Init full text editor
        ExaHelpers.summernoteBySelector('.js-summernote:not(.js-summernote-enabled)');
    }

    initWebcam() {
        let $openCameraBtn = $('#open-camera');
        let $cameraContainer = $('#webcam-container');
        let $snapshotPreview = $('#results');
        let $takeSnapshotBtn = $('#take-snapshot');
        let $reTakeSnapshotBtn = $('#retake-snapshot');

        Webcam.set({
            width: 320,
            height: 240,
            dest_width: 640,
            dest_height: 480,
            image_format: 'jpeg',
            jpeg_quality: 90
        });
        $openCameraBtn.on('click', function (e) {
            $cameraContainer.html('').show();
            $snapshotPreview.html('').hide();
            $reTakeSnapshotBtn.hide();
            $openCameraBtn.hide().next().show();

            Webcam.reset();
            Webcam.attach($cameraContainer.prop('id'));
            $cameraContainer.css('height', '260px');
            $cameraContainer.css('width', '100%');
            $cameraContainer.css('margin-top', '12px');
        }.bind(this));

        let profilePictureDropzone = $('#profile-photo-dropzone').get(0).dropzone;

        $takeSnapshotBtn.on('click', function (e) {
            Webcam.snap(function (data_uri) {
                let capturedFile = this.dataURItoBlob(data_uri);
                profilePictureDropzone.addFile(capturedFile);

                $takeSnapshotBtn.hide();
                $reTakeSnapshotBtn.show();
                $cameraContainer.html('').hide();
                Webcam.reset();
            }.bind(this));
        }.bind(this));

        $reTakeSnapshotBtn.on('click', function (e) {
            $openCameraBtn.click();
        }.bind(this));
    }

    dataURItoBlob(dataURI) {
        // convert base64/URLEncoded data component to raw binary data held in a string
        var byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0)
            byteString = atob(dataURI.split(',')[1]);
        else
            byteString = unescape(dataURI.split(',')[1]);

        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ia], {type: mimeString});
    }

    showEmptyProfessionsAlert() {
        let e = Swal.mixin({
            buttonsStyling: !1,
            customClass: {
                confirmButton: "btn btn-success m-1",
                cancelButton: "btn btn-danger m-1",
                input: "form-control"
            }
        });

        e.fire({
            title: '',
            text: '',
            icon: "warning",
            showCancelButton: 1,
            customClass: {confirmButton: "btn btn-success m-1", cancelButton: "btn btn-danger m-1"},
            confirmButtonText: jsVars.myProfessionsText,
            cancelButtonText: jsVars.closeText,
            html: `<div class="empty-professions-text-red">${jsVars.emptyProfessionsText}</div>`,
            preConfirm: function (e) {
                window.location = jsVars.professionsUrl;
            }
        })
    }

    initProfilePictureDropzone() {
        let $profilePictureDropzone = $('#profile-photo-dropzone');

        $profilePictureDropzone.addClass('dropzone');
        $profilePictureDropzone.dropzone({
            url: jsVars.saveProfilePictureUrl,
            maxFiles: 1,
            acceptedFiles: 'image/*',
            init: function () {
                let thisDropzone = this;
                let $thisElement = $(thisDropzone.element);

                thisDropzone.inputField = $thisElement.find('input');

                let input = thisDropzone.inputField.val();
                if (input === "") {
                    return;
                }

                let file = {
                    processing: true,
                    accepted: true,
                    name: null,
                    size: null,
                    type: null,
                    status: Dropzone.SUCCESS,
                    downloadLink: input,
                    dbData: null,
                };
                thisDropzone.files.push(file);
                thisDropzone.emit("addedfile", file);
                thisDropzone.emit("thumbnail", file, Laravel.app_url + '/storage/' + input);
                thisDropzone.emit("processing", file);
                thisDropzone.emit("success", file, {status: "success"}, false);
                thisDropzone.emit("complete", file);
                // file.path = value.path;

                $thisElement.on('click', '[data-dz-name]', function (e) {
                    let $target = $(e.target);
                    let $fileContainer = $target.parents('.dz-preview');
                    let downloadLink = $fileContainer.find('.dz-file-download-link').val();

                    window.open(Laravel.app_url + '/storage/' + downloadLink, '_blank');
                });
            },
            sending: function (file, xhr, formData) {
                formData.append("_token", Laravel.csrfToken);
            },
            success: function (file, response) {
                if (typeof response.uploadedFile !== "undefined") {
                    // This is an ajax response
                    file.path = response.uploadedFile.path;
                    file.dbData = response.uploadedFile;
                    this.inputField.val(response.uploadedFile.path);
                }
                let link = file.downloadLink || file.path;
                if (link) {
                    // Save download link to hidden input for click to open to work
                    file.previewTemplate.insertAdjacentHTML('beforeend',
                        `<input type="hidden" class="dz-file-download-link" value="${link}" />`);
                }
                if (typeof response.uploadedFile !== "undefined") {
                    $(file.previewElement).addClass("dz-success");
                    setTimeout(function () {
                        $(file.previewElement).removeClass("dz-success");
                    }, 2750);

                    Dashmix.helpers('notify', {
                        align: 'center',
                        type: 'success',
                        icon: 'fa fa-check mr-1 mt-5 mb-5',
                        message: jsVars.fileUploadedSuccessTab
                    });
                }
            },
            error: function (file, message) {
                if (typeof file == "undefined") {
                    console.error(file, message);
                }
                $(file.previewElement).addClass("dz-error");
                if (message.errors) {
                    $(file.previewElement).find('.dz-error-message').text(message.errors.file);
                } else if (message) {
                    $(file.previewElement).find('.dz-error-message').text(message.message);
                }
            },
            addRemoveLinks: true,
            removedfile: function (file) {
                this.inputField.val('');
                var _ref;
                return (_ref = file.previewElement) != null ? _ref.parentNode.removeChild(file.previewElement) : void 0;
            },
        });
    }
}
